import React from "react";
import { useLanguage } from "../contexts/LanguageContext";
import { translate } from "../translations";

function Footer() {
  const { language } = useLanguage();

  return (
    <footer>
      <div className="footer-content">
        <div className="footer-links">
          <a href={`/${language}/privacy-policy`} className="footer-link">
            {translate("privacyPolicy", language)}
          </a>
          <a href={`/${language}/support`} className="footer-link">
            {translate("supportLink", language)}
          </a>
        </div>
        <div className="footer-copyright">
          <img
            src="/assets/ygalaad_logo.png"
            alt="YGALAAD"
            className="footer-logo"
          />{" "}
          &copy; {new Date().getFullYear()}
        </div>
      </div>
    </footer>
  );
}

export default Footer;
